module.exports = __webpack_public_path__ + "img/BasedowKonzert.715bcc8b.svg";